// @flow

import * as NoticeExamples from './Notice';

import {ButtonExamples} from './Button';
import {LinkExamples} from './Link';
import {MenuExamples} from './Menu';
import {BadgeExamples} from './Badge';
import {SectionListExamples} from './SectionList';
import {SectionExamples} from './Section';
import {CheckboxExamples} from './Checkbox';
import {TextareaExamples} from './TextArea';
import {TextFieldExamples} from './TextField';
import {SelectExamples} from './Select';

export type TailorComponentName = string;

export type TailorComponentExample = {|
  rendered: React.Node,
  source: string,
|};

// TODO (matv): Potentially add some sort of helper script that generates the source code
// given a rendered preview

export type TailorComponentsToExamples = {|
  [component: TailorComponentName]: {
    [exampleName: string]: TailorComponentExample,
  },
|};

export const componentToExamples: TailorComponentsToExamples = {
  Notice: NoticeExamples,
  Button: ButtonExamples,
  Link: LinkExamples,
  Menu: MenuExamples,
  Badge: BadgeExamples,
  SectionList: SectionListExamples,
  Section: SectionExamples,
  Checkbox: CheckboxExamples,
  TextArea: TextareaExamples,
  Select: SelectExamples,
  TextField: TextFieldExamples,
};
